module.exports = __webpack_public_path__ + "img/product-shot_05_loading.0794d0ec.jpg";